import { format as dateFnsFormat, isValid } from 'date-fns';

export type DateLike = Date | string | number | null | undefined;

/**
 * Converte qualquer valor em Date válido, ou null.
 */
export function safeParse(value: DateLike): Date | null {
  if (value === null || value === undefined || value === '') return null;
  const date = value instanceof Date ? value : new Date(value);
  return isValid(date) ? date : null;
}

/**
 * Substituto seguro para o `format` do date-fns.
 * Nunca lança "RangeError: Invalid time value" — retorna o fallback.
 */
export function safeFormat(
  value: DateLike,
  pattern: string,
  options?: Parameters<typeof dateFnsFormat>[2],
  fallback = '—',
): string {
  const date = safeParse(value);
  if (!date) return fallback;
  try {
    return dateFnsFormat(date, pattern, options);
  } catch {
    return fallback;
  }
}
